import { render } from "./FoodPyramidGame.vue?vue&type=template&id=48aa689b&scoped=true"
import script from "./FoodPyramidGame.vue?vue&type=script&lang=js"
export * from "./FoodPyramidGame.vue?vue&type=script&lang=js"

import "./FoodPyramidGame.vue?vue&type=style&index=0&id=48aa689b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aa689b"]])

export default __exports__